import _, { groupBy } from 'lodash';
import { createSelector } from 'reselect';
import checkFeatureFlag from 'utils/featureFlags';
import { selectConnections, selectIsGBUser, selectIsLoggedIn, } from 'reducers/selectors';
import { strcmp } from 'utils/sort';
import { selectUnopenedInvestmentAccounts } from 'features/invest/reducers/selectors';
import { emptyArray } from '../../../constants';
export const selectInstalledBankApps = (state) => state.linkBank.installedBankApps;
export const selectShowInstalledBankApps = createSelector([
    (store) => store.user.isLoggedIn,
    (store) => store.utils.featureFlags,
    selectIsGBUser,
], (isLoggedIn, featureFlags, isGBUser) => isGBUser &&
    !isLoggedIn &&
    checkFeatureFlag(featureFlags, 'ab_show_installed_bank_apps'));
const selectGroupedBanks = createSelector([
    (store) => store.linkBank.banks,
    (_, params) => params,
    (store) => store.user.isLoggedIn,
    selectConnections,
    selectInstalledBankApps,
    selectShowInstalledBankApps,
], (banks, { personal, business }, isLoggedIn, connections, installedBankApps, showInstalledBankApps) => {
    let filter = () => true;
    if (business) {
        filter = (bank) => bank.hasBusinessBanking;
    }
    if (personal) {
        filter = (bank) => bank.hasPersonalBanking;
    }
    return groupBy(banks.filter(filter).map((bank) => {
        if (isLoggedIn)
            return bank;
        const isAlreadyAdded = !!connections.find((connection) => connection.bankId === bank.id);
        const isDetectedApp = showInstalledBankApps && !!installedBankApps?.includes(bank.id);
        return { ...bank, isAlreadyAdded, isDetectedApp };
    }), (d) => d.type);
});
export const selectEverydayToLink = createSelector([selectGroupedBanks], (banks) => {
    let banksArray = banks && banks['BANK'] ? banks['BANK'] : [];
    const walletsArray = banks && banks['WALLET'] ? banks['WALLET'] : [];
    banksArray = banksArray.concat(walletsArray);
    const cardsArray = banks && banks['CREDIT_CARD'] ? banks['CREDIT_CARD'] : [];
    return banksArray.concat(cardsArray);
});
export const selectEverydayToLinkOrdered = createSelector([selectEverydayToLink], (data) => {
    const array = data.slice().sort((a, b) => strcmp(a.name, b.name));
    const grouped = _.groupBy(array, (d) => d.name.charAt(0));
    return _.reduce(grouped, (acc, next, index) => {
        acc.push({
            key: index,
            data: next,
        });
        return acc;
    }, []);
});
export const selectInvestmentsToLink = createSelector([
    (store) => store.utils.featureFlags,
    selectGroupedBanks,
    selectUnopenedInvestmentAccounts,
    selectIsLoggedIn,
], (featureFlags, banks, unopenedInvestmentAccounts, isLoggedIn) => {
    let investmentAccounts = banks && banks['INVESTMENT'] ? banks['INVESTMENT'] : [];
    if (checkFeatureFlag(featureFlags, 'investment_providers', 'on') &&
        featureFlags.investment_providers) {
        investmentAccounts = investmentAccounts.concat(JSON.parse(featureFlags.investment_providers.extra.providers));
    }
    if (checkFeatureFlag(featureFlags, 'us_investments', 'on') &&
        featureFlags.us_investments) {
        investmentAccounts = investmentAccounts.concat(JSON.parse(featureFlags.us_investments.extra.providers));
    }
    const cryptoArray = banks && banks['CRYPTO_EXCHANGE'] ? banks['CRYPTO_EXCHANGE'] : [];
    const cryptoWallets = banks && banks['CRYPTO_WALLET'] ? banks['CRYPTO_WALLET'] : [];
    const pension = banks && banks['PENSION'] ? banks['PENSION'] : [];
    const sections = [
        ...(isLoggedIn && unopenedInvestmentAccounts.length
            ? [
                {
                    type: 'investmentAccounts',
                    data: unopenedInvestmentAccounts,
                },
            ]
            : []),
        ...(investmentAccounts.length > 0
            ? [
                {
                    type: 'stocksAndShares',
                    data: investmentAccounts,
                },
            ]
            : []),
        ...(pension.length > 0
            ? [
                {
                    type: 'pensions',
                    data: pension,
                },
            ]
            : []),
        ...(cryptoArray.length > 0
            ? [
                {
                    type: 'cryptoExchanges',
                    data: cryptoArray,
                },
            ]
            : []),
        ...(cryptoWallets.length > 0
            ? [
                {
                    type: 'cryptoWallets',
                    data: cryptoWallets,
                },
            ]
            : []),
    ];
    if (!sections.length) {
        return emptyArray;
    }
    return sections;
});
const emptyIds = [];
export const selectMostPopularBankIds = createSelector([(store) => store.utils.featureFlags], (featureFlags) => (featureFlags.most_popular_banks?.extra?.bankIds || emptyIds));
